export default __webpack_public_path__ + "static/media/contactBanner.f4645611.png";